import { EvoButtonProvider, OidcProvider } from '@changegps/access-identity';
import {
  AccessSidebarContextProvider,
  SnackbarContextProvider,
} from '@changegps/horizon-component-library';

import { AppErrorBoundary } from '@/components';
import { oidcConfig } from '@/config/oidc.config';

import AuthProvider from './auth-provider';
import MuiThemeProvider from './mui-theme-provider';
import { AppPosthogProvider } from './posthog-provider';
import { AppRouterProvider } from './router-provider';
import TanstackQueryProvider from './tanstack-query-provider';
import { ToastProvider } from './toast-provider';

export const rootProvider = [
  [OidcProvider, { ...oidcConfig }],
  AppPosthogProvider,
  TanstackQueryProvider,
  AuthProvider,
  EvoButtonProvider,
  MuiThemeProvider,
  AppErrorBoundary,
  SnackbarContextProvider,
  ToastProvider,
  AccessSidebarContextProvider,
  AppRouterProvider,
];
